import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PhoneIcon from '../../icons/phone.svg';
import Button from '../Button/Button';
import { formatPhone } from '../../utils/phoneFormatter';
import SuccessIcon from '../../icons/success.svg';

import styles from './index.module.scss';

function Step6(props) {
  const { handleClose, getState, data } = props;
  const isDone = getState('done', false);

  useEffect(() => {
    if (isDone) {
      handleClose();
    }
  }, [handleClose, isDone]);

  const phoneNumber = formatPhone(data.jobox_number, true);

  return (
    <div className={styles.success}>
      <SuccessIcon />
      <h4 className={classNames(styles.successTitle, styles.successDesktop)}>Service request submitted</h4>
      <h4 className={classNames(styles.successTitle, styles.successMobile)}>Service requested</h4>
      <p className={styles.successBusiness}>{data.business_name}</p>
      <div className={styles.separator}>
        <p>We will contact you on the provided phone number soon.</p><p>Alternatively, you can also reach out to us by calling the number below:</p>
        <a href={`tel:${data.jobox_number}`}>
          <Button onClick={() => {}}>
            <PhoneIcon />
            {`Call ${phoneNumber}`}
          </Button>
        </a>
      </div>
    </div>
  );
}

Step6.propTypes = {
  data: PropTypes.shape({
    occupation_name: PropTypes.string,
    occupation_id: PropTypes.number,
    business_name: PropTypes.string,
    jobox_number: PropTypes.string,
  }),
  getState: PropTypes.func,
  handleClose: PropTypes.func,
};

export default Step6;
